import ImageCropComponent from './ImageCropContainer';

export default ImageCropComponent;
